import _ from 'lodash'
import { PostFormat } from 'sharedKernel/api'
import { cookies } from 'sharedKernel/cookies/behavior'
import { getCredLocalStorage } from 'sharedKernel/auth/credLocalStorage'
import { IPasswordForm } from '../../ChangePasswordForm/store'
import { IUserConfigForm } from '../../PersonalConfigForm/store/configForm'
import { IProfileImage } from '../../PersonalConfigForm/store/profileImage'
import { cleanCNPJ, cleanZipcode } from './validation'
import { caixaUser } from 'sharedKernel/user/CaixaUser'
import { loggedUser } from 'sharedKernel/user/LoggedUser'


export const createUserRequest = (
  userConfigFormState: IUserConfigForm
): PostFormat => {
  const userId = cookies.get('_cred').id
  const user = loggedUser.get()
  const isCaixaEmployee = caixaUser.isCaixaUser() || user?.role?.name === 'CaixaEmployee'

  const flat = Object.fromEntries(
    Object.entries(userConfigFormState).map(([k, v]) => [k, v?.value ?? null])
  )

  const contact = _.pick(flat, ['phone', 'mobile'])
  const address = {
    ..._.pick(flat, [
      'zipcode',
      'lineOne',
      'number',
      'lineTwo',
      'city',
      'state',
      'country',
      'neighborhood'
    ]),
    zipcode: cleanZipcode(flat.zipcode)
  }

  // Dados básicos comuns
  const baseData = {
    name: flat.name,
    contact,
    address
  }

  // Se for funcionário da Caixa, usar estrutura específica
  if (isCaixaEmployee) {
    return {
      url: `/v1/system/caixa-employee`,
      data: {
        data: {
          id: userId,
          contactName: flat.name || flat.contactName,
          email: flat.email || '',
          language: 'pt-BR',
          timezone: 'America/Sao_Paulo',
          
          caixaRole: flat.caixaRole,
          caixaInstitution: flat.caixaInstitution || 'Caixa Econômica Federal',
          caixaDepartment: flat.caixaDepartment,
          caixaEducation: flat.caixaEducation,

          phone: flat.phone,
          mobile: flat.mobile,
          country: flat.country || 'Brasil',
          
          contact: {
            phone: flat.phone,
            mobile: flat.mobile
          },
          address: {
            zipcode: flat.zipcode,
            lineOne: flat.lineOne,
            lineTwo: flat.lineTwo,
            number: flat.number,
            city: flat.city,
            state: flat.state,
            neighborhood: flat.neighborhood,
            country: flat.country || 'Brasil'
          }
        }
      }
    }
  }

  // Dados específicos para usuários normais (startups)
  const startupInfo = {
    activity: flat.activity || '',
    target: flat.target || '',
    businessModel: flat.businessModel || '',
    numberEmployees: flat.employees || '',
    technologies: flat.technologies || '',
    pitch: flat.pitch || '',
    developmentStage: flat.developmentStage ? Number(flat.developmentStage) : 0,
    annualTurnover: flat.annualRevenue ? Number(flat.annualRevenue) : 0,
    hasRaisedInvestment: flat.hasRaisedInvestment === 'true',
    amount: flat.investmentAmount === '' || flat.investmentAmount == null ? 0 : Number(flat.investmentAmount),
    investmentSource: flat.investmentOrigin || '',
    isSimplifiedResolver: flat.isSimplifiedResolver === 'true'
  }

  // Dados específicos para Prefeituras
  const isAdminCityHall =
    getCredLocalStorage()?.company?.type?.type === 'Admin City Hall'

  const cityHallInfo = isAdminCityHall
    ? {
        name: flat.cityHallName || '',
        mayorName: flat.mayorName || '',
        teamSize: Math.min(5, Math.max(0, Number(flat.teamSize) || 0)),
        hasSecretary: flat.hasSecretary === 'true',
        secretary: flat.secretary || '',
        secretaryResponsible: flat.secretaryResponsible || ''
      }
    : undefined

  const dataBody: Record<string, unknown> = {
    requestSet: '',
    name: flat.name || '',
    email: flat.email || '',
    language: 'pt-BR',
    timezone: 'America/Sao_Paulo',
    contact: {
      phone: flat.phone || '',
      mobile: flat.mobile || ''
    },
    address: {
      zipcode: flat.zipcode || '',
      lineOne: flat.lineOne || '',
      number: flat.number || '',
      lineTwo: flat.lineTwo || '',
      neighborhood: flat.neighborhood || '',
      city: flat.city || '',
      state: flat.state || '',
      country: flat.country || 'Brasil'
    },
    cnpj: cleanCNPJ(flat.cnpj || ''),
    contactName: flat.contactName || flat.name || '',
    site: flat.site || '',
    isEcosystemTermsAccepted: flat.termsAccepted === true || flat.termsAccepted === 'true',
    startupInfo
  }

  if (cityHallInfo !== undefined) {
    dataBody.cityHallInfo = cityHallInfo
  }

  return {
    url: `/v1/system/user/${userId}`,
    data: {
      data: dataBody
    }
  }
}

export const createProfileImageRequest = (profileImage: IProfileImage): PostFormat => {
  const userId: string = cookies.get('_cred').id
  const profileImageData = _.pick(profileImage, ['mimetype', 'name', 'size', 'type', 'content'])
  const postObject: PostFormat = {
    url: '/v1/system/user/profile-image',
    data: { id: `${userId}`, data: profileImageData }
  }
  return postObject
}
